import { ACCOUNTING_WORKFLOW } from './accountingConstants';

export default function AccountingWorkflowNav({ activeSection, onChange, disabled, scanFindingCount = 0 }) {
  return (
    <nav className="admin-pump-accounting-workflow mb-3" aria-label="Accounting integrity workflow">
      {ACCOUNTING_WORKFLOW.map((step) => {
        let badge = null;
        if (step.id === 'monitor' && scanFindingCount > 0) {
          badge = scanFindingCount;
        }

        return (
          <button
            key={step.id}
            type="button"
            className={`admin-pump-accounting-workflow__step ${activeSection === step.id ? 'is-active' : ''}`}
            onClick={() => onChange(step.id)}
            disabled={disabled}
            title={step.hint}
          >
            <span className="admin-pump-accounting-workflow__num">{step.step}</span>
            <span className="admin-pump-accounting-workflow__label">
              {step.label}
              {badge != null && (
                <span className="admin-pump-accounting-workflow__badge">{badge}</span>
              )}
            </span>
          </button>
        );
      })}
    </nav>
  );
}
